<template>
    <div class="action-palette" v-animate-css="{ classes: 'fadeInDown', delay: 0, duration: 300 }">
        <div class="action-palette-top">
            <div class="search-container">
                <span class="material-icons search-icon">search</span>
                <input
                    v-model="searchQuery"
                    type="text"
                    class="search-input"
                    :placeholder="$t('wp.search')"
                />
            </div>
            <div style="display: flex; flex-direction: row; justify-content: end">
                <a-icon style="font-size: 23px" type="close" v-if="bar !== 0" @click="$emit('close-menu', 0)" />
            </div>
        </div>
        <div v-for="(ap, i) in filteredActionPalette" :key="i" v-if="ap.enabled">
            <div class="title" @click="toggleAccordion(i)" style="display: flex; align-items: center">
                {{ $t(`chatbotv2.${ap.group.split(" ").length > 1 ? ap.group.split(" ").join("_") : ap.group}`) }}
                <span class="material-icons" style="margin-left: auto; user-select: none">
                    {{ activeAccordion.includes(i) ? "expand_less" : "expand_more" }}
                </span>
            </div>
            <div class="items" v-show="activeAccordion.includes(i)">
                <div
                    v-for="(subGroup, j) in ap.items"
                    :key="j"
                    class="sub-group"
                    v-if="subGroup.items ? subGroup.items.some((item) => !item.disabled) : !subGroup.disabled"
                >
                    <div v-if="subGroup.group" class="sub-group-title">
                        {{ $t(`chatbotv2.${subGroup.group.split(" ").join("_")}`) }}
                    </div>
                    <button
                        class="item chatbot-btn"
                        v-for="item in subGroup.items || [subGroup]"
                        v-if="!item.disabled"
                        :key="item.id"
                        @dragstart="(ev) => dragStart(ev, item.id)"
                        @drag="(ev) => dragStart(ev, item.id)"
                        @dragend="dragEnd()"
                        :draggable="true"
                    >
                        <div>
                            <BlockIconPreview style="font-size: 24px" :block-type="item.id" class="img" />
                        </div>
                        <div class="d-flex align-items-center align-content-center justify-content-start">
                            <span class="blockTypeText">{{
                                getBlockLabel(item)
                            }}</span>
                        </div>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import log2 from "../../../../../../utils/log2";
import { BlockStyles } from "../../../BlockConfiguration";
import BlockIconPreview from "../common/BlockIconPreview";

const { ActionPalette } = require("../../../BlockConfiguration");
const log = log2("ActionPalette");
export default {
    name: "ActionPalette",
    components: { BlockIconPreview },
    props: ["dragMode", "dragStart", "dragEnd", "addBlockToDiagram", "bar"],
    data() {
        return {
            ActionPalette,
            BlockStyles,
            animationObject: { classes: "fadeInDown", delay: 0, duration: 300 },
            animationInfinite: {
                classes: "fadeIn",
                duration: 5000,
                iteration: "infinite",
            },
            activeAccordion: ActionPalette.map((_, index) => index), // Tüm akordiyonlar açık
            searchQuery: "", // Arama kutusu için
        };
    },
    computed: {
        filteredActionPalette() {
            if (!this.searchQuery.trim()) return this.ActionPalette;
            const query = this.searchQuery.toLocaleLowerCase(this.$i18n.locale);
            // Her bir grup ve altgruptaki item'ları filtrele
            return this.ActionPalette.map((group) => {
                const filteredItems = group.items
                    .map((subGroup) => {
                        if (subGroup.items) {
                            // Altgrup ise
                            const filteredSubItems = subGroup.items.filter((item) => {
                                const label = this.getBlockLabel(item).toLocaleLowerCase(this.$i18n.locale);
                                return label.includes(query);
                            });
                            if (filteredSubItems.length > 0) {
                                return { ...subGroup, items: filteredSubItems };
                            }
                        } else {
                            // Tek item ise
                            const label = this.getBlockLabel(subGroup).toLocaleLowerCase(this.$i18n.locale);
                            if (label.includes(query)) {
                                return subGroup;
                            }
                        }
                        return null;
                    })
                    .filter(Boolean);
                if (filteredItems.length > 0) {
                    return { ...group, items: filteredItems };
                }
                return null;
            }).filter(Boolean);
        },
    },
    methods: {
        getBlockLabel(item) {
            const key = "automation.blocks." + item.id;
            const translated = this.$t(key);
            if (translated && translated !== key) {
                return translated;
            }
            return item.name || item.id.replace(/_/g, " ");
        },
        toggleAccordion(index) {
            if (this.activeAccordion.includes(index)) {
                this.activeAccordion = this.activeAccordion.filter((i) => i !== index);
            } else {
                this.activeAccordion.push(index);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.action-palette {
    box-shadow: 0 4px 20px #00000040;
    background: #ffffff;
    padding: 25px;
    border-radius: 6px;
    height: 75vh;
    overflow: auto;
    width: 500px;

    section:not(:last-child) {
        margin-bottom: 1rem;
    }

    .chatbot-btn {
        border: none;
        background: #fff;
        border-radius: 4px;
        padding: 4px 8px;
        margin: 0;
        min-height: 34px;
        min-width: 34px;
        color: #000;
        display: flex;
        align-items: center;
        margin-bottom: 8px;

        span {
            text-align: left;
        }
    }

    .title {
        margin: 10px 0px;
        font-size: 16px;
        line-height: 1.2;
        font-weight: bold;
        user-select: none;
        cursor: pointer;
        background-color: #f0f0f0;
        padding: 10px;
        border-radius: 4px;
    }

    :nth-child(1) .title {
        margin-top: 0;
    }

    .items {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-gap: 8px;

        .item {
            transition: all 0.3s ease-in-out;
            text-transform: capitalize;
            cursor: grab;
            padding: 10px;

            span {
                color: #22272d;
                font-size: 12px;
                font-weight: 500;
                line-height: 12px;
            }

            .img {
                min-width: 40px;
                height: 40px;
                border-radius: 4px;
                background-color: #06a9f3;
                margin-right: 8px;
                display: flex;
                justify-content: center;
                align-items: center;
                text-align: center;
                &[data-type="OPENROUTER_RESPONSE"],
                &[data-type="OPENAI_RESPONSE"],
                &[data-type="GOOGLE_AI_RESPONSE"],
                &[data-type="ANTHROPIC_RESPONSE"],
                &[data-type="MISTRAL_RESPONSE"],
                &[data-type="AZURE_RESPONSE"],
                &[data-type="BEDROCK_RESPONSE"],
                &[data-type="COHERE_RESPONSE"],
                &[data-type="XAI_RESPONSE"],
                &[data-type="DEEPINFRA_RESPONSE"],
                &[data-type="TOGETHER_RESPONSE"],
                &[data-type="FIREWORKS_RESPONSE"],
                &[data-type="SILICONFLOW_RESPONSE"],
                &[data-type="PARASAIL_RESPONSE"],
                &[data-type="NEBIUS_RESPONSE"],
                &[data-type="ALIBABA_RESPONSE"],
                &[data-type="XIAOMI_RESPONSE"],
                &[data-type="SAMBANOVA_RESPONSE"],
                &[data-type="MOONSHOT_RESPONSE"],
                &[data-type="MINIMAX_RESPONSE"],
                &[data-type="NVIDIA_RESPONSE"] {
                    background: linear-gradient(135deg, #ffffff 60%, #d6deef 100%) !important;
                    color: #22272d !important;
                }

                &[data-type="START_POINT"] {
                    background-color: #566e8a !important;
                    color: #fff !important;
                }

                &[data-type="AI_ASSISTANT"] {
                    background: linear-gradient(162deg, #4b6ae5, #0031f6) !important;
                    color: #fff !important;
                }

                &[data-type="DEFAULT_FALLBACK"] {
                    background-color: #797b8c !important;
                    color: #fff !important;
                }

                &[data-type="DEFAULT_TIMEOUT"] {
                    background-color: #d2ba69 !important;
                    color: #fff !important;
                }

                &[data-type="AI_CALL"] {
                    color: #fff;
                    background-color: rgb(35 35 35 / 84%) !important;
                }

                &[data-type="BOT_RESPONSE"] {
                    background-color: #f5f5f5 !important;
                    color: #647283 !important;
                }

                &[data-type="AI_BOT_RESPONSE"] {
                    background-color: #41ce13 !important;
                    color: #647283 !important;
                }

                &[data-type="AI_CLASSIFICATION"] {
                    background-color: #41ce13 !important;
                    color: #647283 !important;
                }

                &[data-type="FALLBACK"] {
                    background-color: #797b8c !important;
                    color: #ffffff !important;
                }

                &[data-type="TIMEOUT"] {
                    background-color: #d2ba69 !important;
                    color: #fff !important;
                }

                &[data-type="FILTER"] {
                    background-color: #686ad3 !important;
                    color: #fff !important;
                }

                &[data-type="FLOW"] {
                    background-color: #b3d6ff !important;
                    color: #000 !important;
                }

                &[data-type="ATTACHMENT_INPUT"] {
                    background-color: #e7e4e4 !important;
                    color: #647283 !important;
                }

                &[data-type="USER_INPUT"] {
                    background-color: #c9d3de !important;
                    color: #59687b !important;
                }

                &[data-type="GO_TO_STEP"] {
                    background-color: #ffdc67 !important;
                    color: #000 !important;
                }

                &[data-type="ADD_TO_SEGMENT"] {
                    background-color: #9ccb80 !important;
                    color: #22314a !important;
                }

                &[data-type="REMOVE_FROM_SEGMENT"] {
                    background-color: #f5f5f5 !important;
                    color: #22314a !important;
                }

                &[data-type="WEBHOOK"] {
                    background-color: #40455b !important;
                    color: #fff !important;
                }

                &[data-type="SEND_JSON_RESPONSE"] {
                    background-color: #40455b !important;
                    color: #fff !important;
                }

                &[data-type="RUN_JAVASCRIPT"] {
                    background-color: #40455b !important;
                    color: #fff !important;
                }

                &[data-type="SET_ATTRIBUTE"] {
                    background-color: #6e5b8c !important;
                    color: #fff !important;
                }

                &[data-type="QUESTION"] {
                    background-color: #ffad5c !important;
                    color: #000 !important;
                }

                &[data-type="CLOSE_CHAT"] {
                    background-color: #f5f5f5 !important;
                    color: #000 !important;
                }
                &[data-type="UPDATE_TICKET"],
                &[data-type="TICKET_UPDATE"] {
                    background-color: #ad6fe9 !important;
                    color: #ffffff !important;
                }

                &[data-type="TRANSFER_TO_CHATBOT"] {
                    background-color: #ff00ca !important;
                    color: #ffffff !important;
                }

                &[data-type="TRANSFER_CHAT"] {
                    background-color: #76e394 !important;
                    color: #000 !important;
                }

                &[data-type="TAG_CHAT"],
                &[data-type="REMOVE_TAG"] {
                    background-color: #eded67 !important;
                    color: #000 !important;
                }

                &[data-type="SET_DEPARTMENT"] {
                    background-color: #40e6ba !important;
                    color: #000 !important;
                }

                &[data-type="SEND_TRANSCRIPT"] {
                    background-color: #4959da !important;
                    color: #ffffff !important;
                }

                &[data-type="CREATE_TASK"],
                &[data-type="UPDATE_TASK"] {
                    background-color: #73adc5 !important;
                    color: #fff !important;
                }

                &[data-type="SUPPRESSION_ADD"],
                &[data-type="SUPPRESSION_REMOVE"] {
                    background-color: #9d2126 !important;
                    color: #fff !important;
                }

                &[data-type="GET_LOCATION"] {
                    background-color: #7aa8e0 !important;
                    color: #000 !important;
                }

                &[data-type="SUCCESS"] {
                    background-color: #fff !important;
                    color: #00c800 !important;
                }

                &[data-type="FAILURE"] {
                    background-color: #fff !important;
                    color: #ff0000 !important;
                }

                &[data-type="CREATE_EVENT"],
                &[data-type="CREATE_RESERVATION"] {
                    background-color: #033c7c !important;
                    color: #ffffff !important;
                }

                &[data-type="RESERVATION_SELECT_TIME"],
                &[data-type="RESERVATION_SELECT_DAY"],
                &[data-type="RESERVATION_OPEN_URL"],
                &[data-type="RESERVATION_EVENT_LIST"] {
                    background-color: #235603 !important;
                    color: #ffffff !important;
                }
                &[data-type="SEND_MAIL"],
                &[data-type="SEND_SMS"],
                &[data-type="SEND_WP_BUSINESS_MESSAGE"] {
                    background-color: #4ee82f !important;
                    color: #fff !important;
                }

                &[data-type="INSTAGRAM_COMMENT_REPLY"],
                &[data-type="INSTAGRAM_COMMENT_DELETE"],
                &[data-type="INSTAGRAM_COMMENT_SHOW"],
                &[data-type="INSTAGRAM_COMMENT_HIDE"],
                &[data-type="INSTAGRAM_COMMENT_REPLY_AS_PRIVATE"] {
                    background-color: #833ab4 !important;
                    color: #fff !important;
                }
                &[data-type="YOUTUBE_REPLY_COMMENT"],
                &[data-type="YOUTUBE_UPDATE_COMMENT_STATUS"],
                &[data-type="YOUTUBE_SET_MODERATION_STATUS"] {
                    background-color: #FF0000 !important;
                    color: #fff !important;
                }

                &[data-type="GOOGLE_BUSINESS_REPLY_REVIEW"],
                &[data-type="GOOGLE_BUSINESS_UPDATE_REVIEW_STATUS"] {
                    background-color: #4285F4 !important;
                    color: #fff !important;
                }

                &[data-type="GOOGLE_PLAY_REPLY_REVIEW"],
                &[data-type="GOOGLE_PLAY_UPDATE_REVIEW_STATUS"] {
                    background-color: #01875f !important;
                    color: #fff !important;
                }

                &[data-type="APP_STORE_REPLY_REVIEW"],
                &[data-type="APP_STORE_UPDATE_REVIEW_STATUS"],
                &[data-type="APP_STORE_DELETE_REVIEW_RESPONSE"] {
                    background-color: #007aff !important;
                    color: #fff !important;
                }

                &[data-type="AI_MENU_FLOW"] {
                    background-color: #4ee82f !important;
                    color: #fff !important;
                }

                &[data-type="LOOP"],
                &[data-type="LOOP_NEXT"],
                &[data-type="LOOP_BREAK"],
                &[data-type="LOOP_CONTINUE"],
                &[data-type="LOOP_FINISH"] {
                    background-color: #ff00ca !important;
                    color: #ffffff !important;
                }

                &[data-type="REPLY_TRENDYOL_QUESTION"] {
                    background-color: #4ee82f !important;
                    color: #ffffff !important;
                }

                &[data-type="SLEEP"],
                &[data-type="WAIT_FOR"] {
                    background-color: #06a9f3 !important;
                    color: #ffffff !important;
                }

                &[data-type="CREATE_CONTACT"],
                &[data-type="UPDATE_CONTACT"],
                &[data-type="FIND_CONTACTS"],
                &[data-type="FIND_CONTACT"],
                &[data-type="FIND_CHATS"],
                &[data-type="ASSIGN_OWNER"],
                &[data-type="FIND_CHAT"] {
                    color: #ffffff !important;
                    background-color: #ff7a1f !important;
                }

                &[data-type="STRING_FORMAT"],
                &[data-type="NUMBER_FORMAT"],
                &[data-type="DATE_FORMAT"] {
                    background-color: #40455b !important;
                    color: #ffffff !important;
                }

                &[data-type="RECORDS_FROM_CSV"],
                &[data-type="MESSAGE_RECEIVED"],
                &[data-type="ZOHO_ADD_ATTACHMENT_TO_RECORD"],
                &[data-type="ZOHO_UPLOAD_IMAGE_TO_RECORD_FIELD"],
                &[data-type="ZOHO_CREATE_RECORD"],
                &[data-type="ZOHO_FIND_RECORDS_BY_PHONE"] {
                    color: #ffffff !important;
                    background-color: #235603 !important;
                }

                &[data-type="TABLE_CREATE_RECORD"],
                &[data-type="TABLE_DELETE_RECORD"],
                &[data-type="TABLE_UPDATE_RECORD"],
                &[data-type="TABLE_FIND_RECORD"],
                &[data-type="TABLE_FIND_RECORDS"] {
                    background-color: #4959da !important;
                    color: #ffffff !important;
                }
            }
            &:hover {
                box-shadow: 0 4px 10px #00000040;
            }
        }
    }

    .sub-group-title {
        font-size: 14px;
        font-weight: bold;
        margin: 10px 0;
        padding: 5px;
        background-color: #e0e0e0;
        border-radius: 4px;
    }

    .sub-group {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        width: 100%;
    }

    .action-palette-top {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 1rem;
    }

    .search-container {
        display: flex;
        align-items: center;
        background: #f5f6fa;
        border-radius: 8px;
        padding: 6px 12px;
        margin-bottom: 18px;
        box-shadow: 0 2px 8px #00000010;
        border: 1px solid #e0e0e0;
        width: 100%;
        .search-icon {
            font-size: 22px;
            color: #888;
            margin-right: 8px;
        }
        .search-input {
            border: none;
            outline: none;
            background: transparent;
            font-size: 15px;
            width: 100%;
            color: #222;
            padding: 4px 0;
        }
        .search-input::placeholder {
            color: #bbb;
            font-style: italic;
        }
    }
}
</style>
